// Public API Client - No authentication required for public endpoints

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const API_KEY = import.meta.env.VITE_API_KEY || ''

// HTTP Client Functions
export async function get<T>(endpoint: string): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Api-Key': API_KEY,
  }

  const response = await fetch(url, {
    method: 'GET',
    headers,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`(${response.status}): ${errorText}`)
  }

  return response.json()
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function post<T>(endpoint: string, data?: any): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Api-Key': API_KEY,
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: data ? JSON.stringify(data) : undefined,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`(${response.status}): ${errorText}`)
  }

  return response.json()
}

export async function postFormData<T>(endpoint: string, formData: FormData): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const headers: Record<string, string> = {
    'X-Api-Key': API_KEY,
  }

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: formData ? formData : undefined,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`(${response.status}): ${errorText}`)
  }

  return response.json()
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function put<T>(endpoint: string, data?: any): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Api-Key': API_KEY,
  }

  const response = await fetch(url, {
    method: 'PUT',
    headers,
    body: data ? JSON.stringify(data) : undefined,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`(${response.status}): ${errorText}`)
  }

  return response.json()
}

export async function del<T>(endpoint: string): Promise<T> {
  const url = `${API_BASE_URL}${endpoint}`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Api-Key': API_KEY,
  }

  const response = await fetch(url, {
    method: 'DELETE',
    headers,
  })

  if (!response.ok) {
    const errorText = await response.text()
    throw new Error(`(${response.status}): ${errorText}`)
  }

  return response.json()
}

export { API_BASE_URL, API_KEY }
